/**
 * Formats d'étiquettes — catalogue partagé (@itaas/label-print) + préférences navigateur.
 */

export {
  DEFAULT_LABEL_PRINT_FORMAT_ID,
  LABEL_CONTENT_HEIGHT_MM,
  LABEL_CONTENT_WIDTH_MM,
  LABEL_PRINT_FORMAT_GROUPS,
  LABEL_PRINT_FORMATS,
  getGroupedLabelPrintFormats,
  getLabelPrintFormat,
  labelPrintSizeHint,
  resolveLabelPrintLayout,
  type LabelPrintFormat,
  type LabelPrintFormatGroup,
} from "@itaas/label-print";

import {
  DEFAULT_LABEL_PRINT_FORMAT_ID,
  getLabelPrintFormat,
  type LabelPrintFormat,
} from "@itaas/label-print";

const STORAGE_KEY = "hospitol.labelPrintFormat";

export function loadSavedLabelFormat(): LabelPrintFormat {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const found = getLabelPrintFormat(raw);
      if (found) return found;
    }
  } catch {
    /* ignore */
  }
  return getLabelPrintFormat(DEFAULT_LABEL_PRINT_FORMAT_ID)!;
}

export function saveLabelFormat(formatId: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, formatId);
  } catch {
    /* ignore */
  }
}
